import IconWrapper from '.';

export const ActivityLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 4.667V8l2.5 2.5m5-2.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
          stroke={isError ? '#FF1C00' : '#00A46F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};

export const DocumentLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg width="14" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.5 8h5m-5 3.333h5m1.667 4.167H2.834c-.92 0-1.667-.746-1.667-1.667V2.167c0-.92.746-1.667 1.667-1.667h4.654c.221 0 .433.088.59.244l4.512 4.512a.833.833 0 0 1 .244.59v7.987c0 .92-.746 1.667-1.667 1.667Z"
          stroke={isError ? '#FF1C00' : '#00A46F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};

export const TrackingLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg width="16" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m12.714 11.88-3.3 3.301a1.998 1.998 0 0 1-2.828 0l-3.3-3.3a6.667 6.667 0 1 1 9.428 0Z"
          stroke={isError ? '#FF1C00' : '#00A46F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 7.167a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
          stroke={isError ? '#FF1C00' : '#00A46F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};

export const PaymentLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg width="16" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M.5 5.333h15M3.833 9.5h.834M8 9.5h.833M3 12.833h10a2.5 2.5 0 0 0 2.5-2.5V3.667a2.5 2.5 0 0 0-2.5-2.5H3a2.5 2.5 0 0 0-2.5 2.5v6.666a2.5 2.5 0 0 0 2.5 2.5Z"
          stroke={isError ? '#FF1C00' : '#00A46F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};

export const CostLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.788 5.828a.5.5 0 1 0 .755-.656l-.755.656Zm-3.576 4.344a.5.5 0 0 0-.755.656l.755-.656ZM8.5 3.833a.5.5 0 0 0-1 0h1Zm-1 8.334a.5.5 0 0 0 1 0h-1ZM15 8a7 7 0 0 1-7 7v1a8 8 0 0 0 8-8h-1Zm-7 7a7 7 0 0 1-7-7H0a8 8 0 0 0 8 8v-1ZM1 8a7 7 0 0 1 7-7V0a8 8 0 0 0-8 8h1Zm7-7a7 7 0 0 1 7 7h1a8 8 0 0 0-8-8v1Zm0 6.5c-.605 0-1.13-.165-1.49-.404-.363-.242-.51-.522-.51-.763H5c0 .68.413 1.234.955 1.595C6.5 8.29 7.225 8.5 8 8.5v-1ZM6 6.333c0-.24.147-.52.51-.762.36-.24.885-.404 1.49-.404v-1c-.775 0-1.5.208-2.045.572C5.413 5.1 5 5.654 5 6.333h1Zm2-1.166c.822 0 1.475.3 1.788.66l.755-.655C9.992 4.537 9.03 4.167 8 4.167v1ZM8 8.5c.605 0 1.13.165 1.49.404.363.242.51.522.51.763h1c0-.68-.413-1.234-.955-1.595C9.5 7.71 8.775 7.5 8 7.5v1Zm-.5-4.667v.834h1v-.834h-1Zm0 7.5v.834h1v-.834h-1Zm.5-.5c-.822 0-1.475-.3-1.788-.66l-.755.655c.551.635 1.514 1.005 2.543 1.005v-1Zm2-1.166c0 .24-.147.52-.51.762-.36.24-.885.404-1.49.404v1c.775 0 1.5-.208 2.045-.572.542-.361.955-.915.955-1.594h-1Zm-2.5-5v6.666h1V4.667h-1Z"
          fill={isError ? '#FF1C00' : '#00A46F'}
        />
      </svg>
    </IconWrapper>
  );
};

export const TaskLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg width="14" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 7.5a.5.5 0 1 0 0 1v-1Zm2.5 1a.5.5 0 0 0 0-1v1ZM7 10.833a.5.5 0 0 0 0 1v-1Zm2.5 1a.5.5 0 1 0 0-1v1ZM4.5 7.5a.5.5 0 1 0 0 1v-1Zm.009 1a.5.5 0 0 0 0-1v1ZM4.5 10.833a.5.5 0 0 0 0 1v-1Zm.009 1a.5.5 0 1 0 0-1v1Zm7.825-8v10h1v-10h-1ZM11.167 15H2.834v1h8.333v-1Zm-9.5-1.167v-10h-1v10h1ZM2.834 2.667H4.5v-1H2.834v1Zm6.666 0h1.667v-1H9.5v1ZM2.834 15a1.167 1.167 0 0 1-1.167-1.167h-1c0 1.197.97 2.167 2.167 2.167v-1Zm9.5-1.167c0 .645-.523 1.167-1.167 1.167v1c1.197 0 2.167-.97 2.167-2.167h-1Zm1-10c0-1.196-.97-2.166-2.167-2.166v1c.644 0 1.167.522 1.167 1.166h1Zm-11.667 0c0-.644.522-1.166 1.167-1.166v-1c-1.197 0-2.167.97-2.167 2.166h1ZM7 8.5h2.5v-1H7v1Zm0 3.333h2.5v-1H7v1ZM6.167 1h1.667V0H6.167v1Zm1.667 2.333H6.167v1h1.667v-1Zm-1.667 0A1.167 1.167 0 0 1 5 2.167H4c0 1.196.97 2.166 2.167 2.166v-1ZM9 2.167c0 .644-.522 1.166-1.166 1.166v1C9.03 4.333 10 3.363 10 2.167H9ZM7.834 1C8.478 1 9 1.522 9 2.167h1C10 .97 9.03 0 7.834 0v1ZM6.167 0C4.97 0 4 .97 4 2.167h1C5 1.522 5.523 1 6.167 1V0ZM4.5 8.5h.009v-1H4.5v1Zm0 3.333h.009v-1H4.5v1Z"
          fill={isError ? '#FF1C00' : '#00A46F'}
        />
      </svg>
    </IconWrapper>
  );
};

export const PackingLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m8 .5.223-.447a.5.5 0 0 0-.447 0L8 .5Zm6.666 3.333h.5a.5.5 0 0 0-.276-.447l-.224.447Zm-13.333 0-.224-.447a.5.5 0 0 0-.276.447h.5Zm13.333 8.334.224.447a.5.5 0 0 0 .276-.447h-.5ZM8 15.5l-.224.447a.5.5 0 0 0 .447 0L8 15.5Zm-6.667-3.333h-.5a.5.5 0 0 0 .276.447l.224-.447ZM7.776.947l6.667 3.334.447-.895L8.223.053l-.447.894Zm6.667 2.44L7.776 6.718l.447.895L14.89 4.28l-.447-.895Zm-6.22 3.332L1.557 3.386l-.448.895 6.667 3.333.447-.895ZM1.557 4.281 8.223.947 7.776.053 1.11 3.386l.448.895Zm12.886 7.439-6.667 3.333.447.894 6.667-3.333-.447-.895Zm-6.22 3.333-6.666-3.334-.448.895 6.667 3.333.447-.894Zm-6.39-2.886V3.833h-1v8.334h1Zm13.333 0V3.833h-1v8.334h1Zm-7.666-5V15.5h1V7.167h-1Z"
          fill={isError ? '#FF1C00' : '#00A46F'}
        />
      </svg>
    </IconWrapper>
  );
};

export const WorldLoaderIcon = ({ isError }) => {
  return (
    <IconWrapper displayOptions="absolute">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none">
        <path
          fill={isError ? '#FF1C00' : '#00A46F'}
          d="m9.72 14.745-.475.159.474-.159ZM7.356 12.94l-.493.083.493-.083Zm-.061-.364-.493.082.493-.082Zm4.55-2.076-.354.354a.5.5 0 0 0 .354.146v-.5Zm2.302 1.282.475-.158-.475.158Zm-6.185-.262-.137-.48.137.48Zm.824-.235.138.48-.138-.48Zm.85-.74.447.223-.448-.224Zm1.939-.315-.354.353.354-.353ZM9.949 2.46l.32-.383-.32.384Zm.18 1.24.416.278-.416-.277Zm-.426.64-.416-.278.416.278Zm-.967.738.158.475-.158-.475Zm-.119.04-.158-.474.158.474Zm-6.771 6.007.121.485a.5.5 0 0 0 .326-.261l-.447-.224Zm.572-1.143-.448-.224.448.224Zm2.154.611.4-.3-.4.3Zm-.566-.754-.4.3.4-.3Zm1.59-.902-.224-.447a.5.5 0 0 0-.24.633l.464-.185Zm.353.883.464-.186-.464.186Zm1.837-1.978-.224-.447.224.447Zm-2.22 2.986.223.447-.224-.447ZM8.14 6.505l-.416.278.416-.278Zm6.154 5.718.413.281-.413-.281Zm-12.959-.97-.45.217.45-.218Zm7.722-9.534-.32.384.32-.384ZM11.721 5.5a.5.5 0 1 0-1 0h1ZM10.043 7a.5.5 0 0 0 .662.75L10.043 7ZM1.097 8a7 7 0 0 1 7-7V0a8 8 0 0 0-8 8h1Zm6.754 4.858-.06-.365-.987.165.06.365.987-.165ZM11.846 11h.524v-1h-.524v1ZM8.1 12l.824-.235-.275-.961-.824.235.275.962Zm1.952-1.171.03-.061-.894-.447-.03.06.894.448Zm1.17-.246.27.27.707-.707-.27-.27-.708.707Zm-.504-.208c.189 0 .37.075.503.208l.707-.707a1.711 1.711 0 0 0-1.21-.501v1Zm-1.794 1.39c.49-.14.9-.48 1.128-.936l-.894-.447a.82.82 0 0 1-.51.422l.276.961Zm1.159-.997a.71.71 0 0 1 .635-.393v-1c-.648 0-1.24.366-1.53.946l.895.447Zm-2.295 1.725a.437.437 0 0 1 .312-.492l-.275-.962c-.703.201-1.143.898-1.023 1.619l.986-.165Zm.376.632a.32.32 0 0 1-.315-.267l-.986.165a1.32 1.32 0 0 0 1.301 1.102v-1ZM12.37 11c.591 0 1.117.379 1.304.94l.949-.316A2.375 2.375 0 0 0 12.37 10v1Zm-2.176 3.587a2.138 2.138 0 0 0-2.029-1.462v1c.49 0 .925.314 1.08.778l.949-.316ZM8.738 2.103l.89.742.64-.768-.89-.742-.64.768Zm.975 1.32-.426.64.832.554.426-.639-.832-.554ZM8.578 4.605l-.119.04.316.948.119-.04-.316-.948ZM1.97 9.758 1.4 10.901l.894.448.572-1.144-.895-.447Zm3.002.535-.566-.754-.8.6.566.754.8-.6Zm.16-1.17.353.882.928-.371-.353-.882-.928.371Zm2.43-1.728L5.372 8.49l.448.895L8.01 8.29l-.448-.895Zm-2.077 2.61a.296.296 0 0 1-.143.375l.447.895a1.296 1.296 0 0 0 .624-1.641l-.928.371Zm-2.62.2a.437.437 0 0 1 .741-.066l.8-.6a1.438 1.438 0 0 0-2.436.22l.895.446Zm1.307.688a1.296 1.296 0 0 0 1.617.382l-.447-.895a.296.296 0 0 1-.37-.087l-.8.6Zm3.553-4.11a.423.423 0 0 1-.163.612l.448.895a1.423 1.423 0 0 0 .547-2.062l-.832.555Zm.734-2.14a1.423 1.423 0 0 0-.734 2.14l.832-.555a.423.423 0 0 1 .218-.636l-.316-.948Zm.828-.58c-.17.254-.42.444-.71.541l.317.949a2.375 2.375 0 0 0 1.225-.936l-.832-.555Zm.342-1.218a.438.438 0 0 1 .084.579l.832.554a1.438 1.438 0 0 0-.276-1.901l-.64.768ZM8.22.525v.473h1V.526h-1ZM8.096 1c.197 0 .391.008.584.024l.082-.997A8.1 8.1 0 0 0 8.096 0v1Zm.584.024A7 7 0 0 1 15.096 8h1A8 8 0 0 0 8.762.027l-.082.997Zm4.994 10.916.147.44.949-.316-.147-.44-.949.316ZM15.096 8a6.966 6.966 0 0 1-1.214 3.94l.826.565A7.965 7.965 0 0 0 16.096 8h-1Zm-1.214 3.94a7.01 7.01 0 0 1-4.103 2.857l.239.97a8.01 8.01 0 0 0 4.69-3.262l-.826-.564ZM9.78 14.798A7.019 7.019 0 0 1 8.096 15v1c.662 0 1.306-.08 1.922-.232l-.24-.971Zm.594.327-.18-.537-.948.316.179.537.949-.316ZM1.725 10.64l-.51.127.242.97.51-.127-.242-.97ZM8.096 15a7 7 0 0 1-6.31-3.965l-.9.435A8 8 0 0 0 8.096 16v-1Zm-6.31-3.965A6.97 6.97 0 0 1 1.096 8h-1c0 1.242.283 2.42.79 3.47l.9-.435Zm7.592-9.7a.438.438 0 0 1-.157-.337h-1c0 .427.19.832.517 1.105l.64-.769ZM10.721 5.5c0 .597-.261 1.133-.678 1.5l.662.75a2.994 2.994 0 0 0 1.016-2.25h-1Z"
        />
      </svg>
    </IconWrapper>
  );
};
